<template>
  <div v-loading="loading">
    <div v-if="!loading">
      <!--渲染表单-->
      <form-render class="process-form" ref="form" :forms="forms" :isAgainShenPi="isAgainShenPi" v-model="formData" />
      <!-- @input="input" -->
    </div>
    <!-- <el-divider>审批流程</el-divider> -->
    <!-- <div> -->
    <!--渲染流程执行过程-->
    <!-- <el-alert
        type="warning"
        description="开源版后台只是为了演示流程设计功能，后台无法处理流程发起的后续步骤，如需要完整的工作流功能请移步 👉 pro 版本"
      ></el-alert>
      <el-link href="http://106.13.16.28:83">访问pro👉 </el-link>
      <el-timeline :reverse="false"> -->
    <!--<el-timeline-item v-for="(activity, index) in activities" :key="index">

          </el-timeline-item>-->
    <!-- </el-timeline>
    </div> -->
  </div>
</template>

<script>
import FormRender from '@/views/common/form/FormRender'
import FormRender1 from '@/views/common/form/FormRender1'
import FormDesignRender from '@/views/admin/layout/form/FormDesignRender'
import { getFormDetail, GetFlowInstance } from '@/api/design'

export default {
  name: 'InitiateProcess',
  components: { FormDesignRender, FormRender, FormRender1 },
  props: {
    code: {
      type: String,
      required: true,
    },
    againShenPi: {
      type: String,
      default: '',
    },
    // againShenPi: {
    //   type: Object,
    //   default: () => {
    //     return {}
    //   },
    // },
    instanceId: {
      type: String,
      default: '',
    },
    isAgainShenPi: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      // isAgainShenPi: false,
      formData: {},
      form: {
        formId: '',
        formName: '',
        logo: {},
        formItems: [],
        process: {},
        remark: '',
      },
    }
  },
  mounted() {
    console.log(this.code, 'this.code')
    // if (this.instanceId) {
    //   this.isAgainShenPi = true
    // } else {
    //   this.isAgainShenPi = false
    // }
    this.loadFormInfo(this.code)
  },
  computed: {
    forms() {
      return this.$store.state.design.formItems
    },
  },
  methods: {
    // 添加判断是否重新审批流程
   loadFormInfo(formId) {
      this.loading = true
      getFormDetail({ tptId: formId })
        .then((rsp) => {
          console.log('rsp---------', rsp)
          this.loading = false
          console.log(rsp.data)
          let form = rsp.data
          form.logo = JSON.parse(form.logo)
          form.settings = JSON.parse(form.settings)
          // 判断是否重新提交
          if (this.isAgainShenPi) {
            let list = JSON.parse(this.againShenPi)
            list.forEach((item) => {
              item.flag = 1,
              item.perm = ''
              if (item.name === 'NumberInput') {
                item.value = Number(item.value)
              }
            })
            form.formItems = list
          } else {
            form.formItems = JSON.parse(form.formItems)
          }

          // form.process = JSON.parse(form.process)
          // this.form = form
          // //构建表单及校验规则
          // this.$store.state.design = form

          form.process = JSON.parse(form.process)
          this.form = form
          this.$store.state.design = form // 确保 formItems 正确设置到 Vuex 状态中
          // 初始化 formData
          this.formData = {}
          form.formItems.forEach((item) => {
            this.$set(this.formData, item.id, item.value || null) // 确保 formData 初始化正确
          })
        })
        .catch((err) => {
          this.loading = false
          this.$message.error(err)
        })
    },

    validate(call) {
      this.$refs.form.validate(call)
    },
  },
}
</script>

<style lang="less" scoped>
.process-form {
  /deep/ .el-form-item__label {
    padding: 0 0;
  }
}
</style>
